import * as React from 'react';
import LeadForm from '../LeadForm';
import { CardHeaderUI } from '@makemydeal/dr-activities-common';
import { ILeadFormConstants } from '../LeadFormConstants';
import { Selectors } from '../../../store/selectors';
import { IConfigLeadform } from '../../../types/IConfigLeadform';

export interface ISummaryLeadFormStateProps {
    headerSecondaryText: string;
    failedZipCode: string;
    successfulZipCode: string;
    hasEnteredSuccessfulZipCode: boolean;
    taxesAndFees: string;
    taxesAndFeesWithoutUpfront: string;
    isError: boolean;
    paymentAmountCopy?: string;
    paymentAmountValue?: string;
    showZipForm: boolean;
    leadFormConstants: ILeadFormConstants;
    isPaymentInvalid: boolean;
    showErrorMessage: boolean;
    errorMessage: string;
    propCopySubHeader: string;
    zipHeader: string;
    offerHasBeenSent?: boolean;
    shopperName?: string;
    config: IConfigLeadform;
    selector: Selectors;
}

export interface ISummaryLeadFormDispatchProps {
    dispatchAnalytics: { (type: string, description: string) };
}

export type ISummaryLeadFormProps = ISummaryLeadFormStateProps & ISummaryLeadFormDispatchProps;

class SummaryLeadFormUI extends React.Component<ISummaryLeadFormProps, any> {
    constructor(props) {
        super(props);
    }

    renderZipSubtext = () => {
        if (this.props.hasEnteredSuccessfulZipCode) {
            return (
                <div className="zip-text">
                    {/* tslint:disable-next-line:max-line-length */}
                    We updated your summary to include taxes & fees of <strong>{this.props.taxesAndFeesWithoutUpfront}</strong>{' '}
                    based on your location of {this.props.successfulZipCode}.{this.props.paymentAmountCopy}{' '}
                    <strong>{this.props.paymentAmountValue}</strong>
                </div>
            );
        }
        return null;
    };

    renderHeadingSection = (leadFormConstants: ILeadFormConstants) => {
        const summaryLeadFormInformation = leadFormConstants.heading ? (
            <div className="summary-lead-form-information">{leadFormConstants.heading}</div>
        ) : null;
        const summaryLeadFormDisclaimer = leadFormConstants.heading ? (
            <div className="summary-lead-form-disclaimer">{leadFormConstants.subHeading}</div>
        ) : null;
        return (
            <>
                {summaryLeadFormInformation}
                {summaryLeadFormDisclaimer}
            </>
        );
    };

    renderZipSection = () => {
        return (
            <div className="summary-lead-form-zip-box">
                <div className="summary-lead-form-zip-text">
                    <div className="zip-header">
                        {this.props.zipHeader ? this.props.zipHeader : 'Calculate taxes & fees for this vehicle.'}
                    </div>
                    {this.renderZipSubtext()}
                </div>

                {this.props.config.utils.renderZipUpdater({
                    pageId: 'Summary Lead Form'
                })}

                {this.props.config.utils.renderPaymentError({
                    message: this.props.errorMessage,
                    dontShowRetry: true,
                    pageId: 'Summary Lead Form',
                    isError: this.props.showErrorMessage
                })}

                <hr />
            </div>
        );
    };

    render() {
        const { propCopySubHeader, headerSecondaryText, showZipForm, offerHasBeenSent } = this.props;

        const leadFormConstants: ILeadFormConstants = this.props.leadFormConstants;
        return (
            <div className="summary-lead-form">
                <CardHeaderUI
                    cardHeading={leadFormConstants.pageTitle}
                    secondaryText={propCopySubHeader ? propCopySubHeader : headerSecondaryText}
                />
                {this.renderHeadingSection(leadFormConstants)}
                {showZipForm && this.renderZipSection()}

                {this.props.config.utils.renderDealSummary({
                    isStatic: false,
                    purchaseTermsIsOpen: false,
                    capCostIsOpen: false,
                    leaseSigningIsOpen: false,
                    tradeInIsOpen: false,
                    taxesAndFeesIsOpen: false,
                    hideStartLinks: true
                })}

                <LeadForm
                    zipCode={this.props.successfulZipCode}
                    isLeadFormLite={true}
                    hideTitle={true}
                    isLeadSummary={true}
                    offerHasBeenSent={offerHasBeenSent}
                    selector={this.props.selector}
                    config={this.props.config}
                />
            </div>
        );
    }
}

export default SummaryLeadFormUI;
